import { render, staticRenderFns } from "./viewheader.vue?vue&type=template&id=06f5dec0&scoped=true&"
import script from "./viewheader.vue?vue&type=script&lang=js&"
export * from "./viewheader.vue?vue&type=script&lang=js&"
import style0 from "./viewheader.vue?vue&type=style&index=0&id=06f5dec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f5dec0",
  null
  
)

export default component.exports